export default "__VITE_ASSET__DDaexjtH__"